module.exports = __webpack_public_path__ + "content/81b84a2adecacfe1f8efd7a62186871e.png";